export const decimalAlphaToHex = (alpha) =>
  alpha === 0 ? "00" : Math.round(255 * alpha).toString(16);
